import { Flex, Box } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import Worker from "../utils/pdfExport.worker";


export const ExportToPdfButton = ({dataList, gameName}) => {
    const [worker, setWorker] = useState(null)
    const [processing, setProcessing] = useState(false)

    useEffect(() => {
        const worker = new Worker();
        worker.onmessage = async function(event) {
            console.log("Main thread received:", event.data)
            if (event.data.action === "generation_completed") {

                const pdfURL = URL.createObjectURL(event.data.pdfBlog);

                // Create a link element to download the PDF, then click to trigger download
                const downloadLink = document.createElement('a');
                downloadLink.href = pdfURL;
                downloadLink.download = `${gameName.replace(" ", "_")}_trend.pdf`;
                downloadLink.click();

                // Cleanup: Revoke the URL object
                URL.revokeObjectURL(pdfURL);
            }
            setProcessing(false)
        }
        setWorker(worker)

        return () => {
            worker.terminate();
        };
    }, [])

    const handleClick = () => {
        if (worker) {
            setProcessing(true)
            const data = {action:"generate_pdf", dataList, gameName}
            worker.postMessage(data)
        }
    }

    return (
        <Flex
            as="button"
            width="90px"
            cursor="pointer"
            bg="#282828"
            borderRadius="10px"
            padding="5px"
            color="#ff9900"
            justifyContent="center"
            alignItems="center"
            onClick={handleClick}
            disabled={processing}
        >
            <span className="material-symbols-outlined">download</span>
            <Flex as="span" marginLeft="3px" justify="center" width="100%">
                {processing ? <Processing /> : "Export"}
            </Flex>
        </Flex>
    )
}


const Processing = () => {
    return (
        <Flex gap="3px">
            <Dot/>
            <Dot/>
            <Dot/>       
        </Flex>
    )
}

const Dot = () => {
    const pulse = `
        @keyframes pulse {
            0% {transform: scale(1);}
            50% {transform: scale(1.4);}
            100% {transform: scale(1);}
        }
    `

    return (
        <Box
            animation="pulse 0.5s infinite linear"
            width="5px"
            height="5px"
            padding="1px"
            css={pulse}
        >
            <Box
                bg="#ff9900"
                width="100%"
                height="100%"
                borderRadius="50%"
            />
        </Box>
    )
}
